module.exports = __webpack_public_path__ + "static/img/Stats-Off.b3fdf6b3.svg";